import Radio from '../../design-system/radio';
import {
  SUBSCRIPTION_INPUT_NAME,
  QUANTITY_INPUT_NAME,
  FLAVOR_INPUT_NAME,
  PRICE_SECTION_ID
} from '../../classnames/above-the-fold';

export default class Selectors {
  radioButton = new Radio();

  constructor(container) {
    this.container = container;
  }

  getSubscriptionState() {
    return this.radioButton.getValueByName(SUBSCRIPTION_INPUT_NAME, this.container);
  }

  isSubscription(buttonSubscriptionState = null) {
    const subscriptionValue = buttonSubscriptionState || this.getSubscriptionState();

    return subscriptionValue === 'subscription';
  }

  getQuantity() {
    return parseFloat(this.radioButton.getValueByName(QUANTITY_INPUT_NAME, this.container) || 1);
  }

  getVariantId() {
    const selectedVariantId = this.radioButton.getValueByName(FLAVOR_INPUT_NAME, this.container);
    const defaultVariantId = document.getElementById(PRICE_SECTION_ID).dataset.variantId;

    return selectedVariantId || defaultVariantId;
  }

  getVariantData() {
    return window.variantDataSelector.getData(this.getVariantId());
  }
}
